import { clsx } from 'clsx';
import { useTheme } from './useTheme.mjs';
import { jsx } from 'react/jsx-runtime';

const ThemedChildren = ({
  className = undefined,
  children
}) => {
  const {
    className: themeClass
  } = useTheme();
  return /*#__PURE__*/jsx("div", {
    className: clsx(themeClass, className),
    children: children
  });
};

export { ThemedChildren };
//# sourceMappingURL=ThemedChildren.mjs.map
